import * as React from 'react';
import { Chip } from '../chip';
import { StyledContentWrapper, StyledDescription, StyledImage, StyledLabel, StyledLabelWrapper, StyledListItem, ChildrenContainer } from './ListItem.styled';
import { Pictogram } from '../pictogram';
export const ListItem = (props) => {
    const { label, description, chip, media, pictogram, children, } = props;
    return (React.createElement(React.Fragment, null,
        React.createElement(StyledListItem, Object.assign({ tabIndex: props.onClick && !props.disabled ? 0 : undefined, onKeyUp: (e) => {
                if (e.key === 'Enter' && props.onClick) {
                    props.onClick();
                }
            } }, props),
            media && React.createElement(StyledImage, { src: media.url, alt: media.alt }),
            !media && pictogram && React.createElement(Pictogram, Object.assign({}, pictogram)),
            React.createElement(StyledContentWrapper, null,
                React.createElement(StyledLabelWrapper, null,
                    React.createElement(StyledLabel, Object.assign({ className: "list-item-label" }, props), label),
                    chip && React.createElement(Chip, Object.assign({}, chip))),
                React.createElement(StyledDescription, Object.assign({ className: "list-item-description" }, props), description)),
            children && React.createElement(ChildrenContainer, null, children))));
};
//# sourceMappingURL=ListItem.js.map